var map = {
	"./photo1.webp": 845,
	"./photo10.webp": 784,
	"./photo11.webp": 352,
	"./photo12.webp": 21,
	"./photo13.webp": 82,
	"./photo14.webp": 983,
	"./photo15.webp": 692,
	"./photo16.webp": 553,
	"./photo17.webp": 46,
	"./photo18.webp": 235,
	"./photo19.webp": 856,
	"./photo2.webp": 592,
	"./photo20.webp": 408,
	"./photo21.webp": 315,
	"./photo22.webp": 970,
	"./photo23.webp": 837,
	"./photo24.webp": 756,
	"./photo25.webp": 455,
	"./photo26.webp": 550,
	"./photo3.webp": 803,
	"./photo4.webp": 414,
	"./photo5.webp": 137,
	"./photo6.webp": 772,
	"./photo7.webp": 863,
	"./photo8.webp": 882,
	"./photo9.webp": 981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 403;